import { render, staticRenderFns } from "./CarInfo.vue?vue&type=template&id=36c1ed69"
import script from "./CarInfo.vue?vue&type=script&lang=js"
export * from "./CarInfo.vue?vue&type=script&lang=js"
import style0 from "./CarInfo.vue?vue&type=style&index=0&id=36c1ed69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports